import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import { ApiDocsUrls, ApiContactSupportUrls } from '../constants';
import { messages } from './messages';
import style from './style.module.less';

/**
 * This component renders the Resources blocks for the selected API version
 * @param {object} props
 * @param {string} props.selectedApiVersion - Version of the API Key.
 * @returns {JSX.Element} The rendered component.
 */
export const Resources = ({ selectedApiVersion }) => {
  return (
    <>
      <Text element='h3' textType={TextType.H3} value={messages.resources} />

      <section className={style['settings-resources-wrapper']}>
        <div className={style['settings-resources-item']}>
          <Text element='h4' textType={TextType.H4} value={messages.resourceDocTitle} />
          <Text element='p' textType={TextType.Paragraph} value={messages.resourceDocText} />

          <a href={ApiDocsUrls[selectedApiVersion]} rel='noreferrer' target='_blank'>
            <Text element='span' textType={TextType.Paragraph} value={messages.resourceDocLink} />
          </a>
        </div>

        <div className={style['settings-resources-item']}>
          <Text element='h4' textType={TextType.H4} value={messages.resourceHelpTitle} />
          <Text element='p' textType={TextType.Paragraph} value={messages.resourceHelpText} />
          <Text
            element='a'
            href={ApiContactSupportUrls[selectedApiVersion]}
            textType={TextType.Paragraph}
            value={messages.resourceHelpLink}
          />
        </div>
      </section>
    </>
  );
};
